import { getAddresses } from "../../api"
import { newNotification } from "../../store"
import { get } from "svelte/store"
import { _ } from "svelte-i18n"
export async function validateAndSaveAddress(
    selectedAddress: Address,
    dealerNumber: number,
    submitAddressFrom: Function,
    addressFormElement: HTMLFormElement
) {
    if (selectedAddress?.customerNumber) {
        const allCompaniesWithSameCustomerNumber = await getAddresses({
            customerNumber: selectedAddress?.customerNumber,
            type: "company",
            dealerNumber: dealerNumber,
        })
        if (
            (allCompaniesWithSameCustomerNumber.data.length == 1 &&
                allCompaniesWithSameCustomerNumber.data[0]?.id !== selectedAddress?.id) ||
            allCompaniesWithSameCustomerNumber.data.length > 1
        ) {
            newNotification({
                class: "error",
                html: get(_)("address.customerNumberAlreadyTaken"),
            })
            return
        }
    }
    if (selectedAddress?.deliveryAddress === undefined) {
        newNotification({
            class: "error",
            html: get(_)("address.decideCompAndShipAddress"),
        })
        return
    }

    if (addressFormElement.checkValidity()) {
        submitAddressFrom(true)
    } else {
        addressFormElement.reportValidity()
        const invalidFields = Array.from(addressFormElement.querySelectorAll(":invalid"))
        console.log("INVALID FIELDS", invalidFields)

        newNotification({
            class: "error",
            html: get(_)("address.fillOutMandatoryFields"),
        })
    }
}
